module.exports = __webpack_public_path__ + "img/shop-img-4.93f45dcc.png";